import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-header" }
const _hoisted_2 = { class: "header-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" Tandem Setup | "),
  /*#__PURE__*/_createElementVNode("span", null, "Term Planner")
], -1)
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "cal-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Finalize Term Planner", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " Once your Term Planner is finalized, your course will be ready to launch. If needed, you will be able to make adjustments to assignment dates by editing your Content Schedule. Are you ready to finalize? ", -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, "Oops!", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "An error occurred while saving the schedule edits."),
  /*#__PURE__*/_createTextVNode(" The Tandem team has been notified and will get back to you as soon as possible. Thanks for your patience and understanding. ")
], -1)

import { ref, onMounted } from "vue";
import { Settings } from "luxon";
import TandemModal from "@/components/TandemModal.vue";
import PlannerCalendar from "@/components/PlannerCalendar.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import useSnapshots from "@/composables/useSnapshots";
import useSchedulePlanSync from "@/composables/useSchedulePlanSync";

export interface Props {
  cohortId: string;
  schedulePlanId: string;
  timezone: string;
  finalizeRedirectUrl: string;
  criticalError?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TermPlanner',
  props: {
    cohortId: {},
    schedulePlanId: {},
    timezone: {},
    finalizeRedirectUrl: {},
    criticalError: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const { loadSchedulePlan, finalizePlan, canFinalize } = useSchedulePlanSync(
  props.cohortId
);
useSnapshots();

const initialized = ref(false);
const showConfirmation = ref(false);
const showError = ref(false);
const finalizing = ref(false);

const handleFinalize = async () => {
  try {
    finalizing.value = true;
    await finalizePlan();
    showConfirmation.value = false;
    window.location.href = props.finalizeRedirectUrl;
  } catch (err) {
    showConfirmation.value = false;
    showError.value = true;
    finalizing.value = false;
    throw err;
  }
};

onMounted(async () => {
  Settings.defaultZone = props.timezone;
  await loadSchedulePlan(props.schedulePlanId);
  initialized.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-wrapper", { 'calendar-errors': _ctx.criticalError }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-burg",
          disabled: !_unref(canFinalize),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ((showConfirmation.value = true)))
        }, " Finalize ", 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (initialized.value || _ctx.criticalError)
        ? (_openBlock(), _createBlock(PlannerCalendar, { key: 0 }))
        : (_openBlock(), _createBlock(LoadingIndicator, { key: 1 }))
    ]),
    _createVNode(TandemModal, {
      modelValue: showConfirmation.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showConfirmation).value = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_6
      ]),
      directions: _withCtx(() => [
        _hoisted_7
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ((showConfirmation.value = false)))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "btn btn-burg",
          type: "button",
          disabled: finalizing.value,
          onClick: handleFinalize
        }, [
          (!finalizing.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Yes, Finalize ")
              ], 64))
            : (_openBlock(), _createElementBlock("i", _hoisted_9, " Finalizing… "))
        ], 8, _hoisted_8)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(TandemModal, {
      modelValue: showError.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showError).value = $event))
    }, {
      title: _withCtx(() => [
        _hoisted_10
      ]),
      directions: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})